export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationMember/state.js